import React from 'react'
import { OverlayView } from '@react-google-maps/api'
import defaultLandmarkImage from '../../../../assets/images/property-location.png'

type CoordinatesTypes = {
    lat: number
    lng: number
}
type LandmarkPinsTypes = {
    position: CoordinatesTypes
    icon?: string | undefined
    data?: object | undefined
    handlePinClick?: any
}

const LandmarkPins = (props: LandmarkPinsTypes) => {
    const { position, icon, handlePinClick, data } = props

    return (
        <>
            <OverlayView
                key={`${position.lat}<>${position.lng}`}
                position={{ lat: position.lat, lng: position.lng }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
                {
                    icon
                        ?
                        <div className="custom-overlay"
                            onClick={(): void => handlePinClick(data)}
                        >
                            <div
                                className={'custom-overlay-content'}
                                style={{
                                    backgroundImage: `url(${icon})`
                                }}
                            />
                        </div>
                        :
                        <img className="fallback-image" src={defaultLandmarkImage} />
                }
            </OverlayView>
        </>
    )
}

export default LandmarkPins